module.exports = __webpack_public_path__ + "img/crew_upgrade3_7-7-2021.227f0fe5.jpg";